import Locker from "@components/global/Locker/Locker";
import mainLocationsStore from "@mobx/store/locations";
import makeAddress from "@mobx/utils/makeAddress";
import { makeMinerName } from "@utils/parseMinerName";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import RefreshRacks3 from "../RefreshRacks3";
import styles from "./RackTableHeader.module.scss";

export interface IRackTableHeader3Props {};

const useControl = (
  props: IRackTableHeader3Props
) => {
  const locationStore = mainLocationsStore?.activeLocation;
  const buildingStore = locationStore?.activeBuilding;

  const address = useMemo(() => {
    const defaultAddress = makeAddress(locationStore?.location.Code, buildingStore?.building.name, buildingStore?.activeRackBLI);

    if (buildingStore?.activeMinerBLI) {
      return defaultAddress + makeMinerName(buildingStore.activeMinerBLI);
    }

    return defaultAddress + (buildingStore?.activeCellBLI ?? "");
  }, [locationStore?.location.Code, buildingStore?.building.name, buildingStore?.activeRackBLI, buildingStore?.activeMinerBLI, buildingStore?.activeCellBLI]);

  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        buildingStore?.setLocked(true);
      }
    };
    document.addEventListener("keydown", listener);
    return () => document.removeEventListener("keydown", listener);
  }, []);

  return {
    lockRacks: !!buildingStore?.isLocked,
    address,

    onToggleLock() {
      buildingStore?.toggleLock();
    },
  };
};

const RackTableHeader3 = observer((props: IRackTableHeader3Props) => {
  const control = useControl(props);
  return (
    <div className={styles.building_name}>
      <div>
        <p>{control.address}</p>
        <Locker
          lock={control.lockRacks}
          onClick={control.onToggleLock}
          green
        />
      </div>
      <RefreshRacks3 />
    </div>
  );
});

RackTableHeader3.displayName = "RackTableHeader3";

export default RackTableHeader3;
